import React, { useContext, useRef, FC } from "react";
import { NotificationsState, NotificationOptions, defaultNotificationOptions } from "./types/NotificationTypes";
import { Notifications, NotificationsRef } from "../components/common/Notifications";

const initialState: NotificationsState = {
  notify: () => {},
};

const NotificationContext = React.createContext<NotificationsState>(initialState);

export const NotificationProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const notificationsRef = useRef<NotificationsRef>(null);

  const notify = (notification: NotificationOptions) => {
    if (!notificationsRef.current) {
      console.warn("Notification system is not initialized");
      return;
    }

    try {
      const mergedNotification = {
        ...defaultNotificationOptions,
        ...notification,
      };
      
      notificationsRef.current.addNotification(mergedNotification);
    } catch (error) {
      console.error("Failed to show notification:", error);
    }
  };

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <Notifications ref={notificationsRef} defaultOptions={defaultNotificationOptions} />
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotifications must be used within a NotificationProvider");
  }
  return context;
};
